import {mount} from 'svelte';

import InitializeLayout from '@js/layout';
import AnimateElement from '@js/modules/animateElement';

import PlanIndex from '@js/components/plan/PlanIndex.svelte';

InitializeLayout();

// The presentation sections under the app (concepts, FAQ) appear on scroll
AnimateElement.initialize();

const target = document.getElementById('plan-component');

const allFilters = JSON.parse(target.getAttribute('data-all-filters') || {});

mount(PlanIndex, {
    target,
    props: {
        allFilters: allFilters,
        placesCount: parseInt(target.getAttribute('data-places-count'), 10) || 0,
        planReminders: target.getAttribute('data-plan-reminders') === 'true'
    }
});
